import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import styled from 'styled-components';

import { getDeviceType } from '_helpers/device';
import { getSalePageURL } from '_helpers/urls';

import { refreshDevice, refreshSalePageURL } from '_redux/general/slice';
import { getProducts } from '_redux/products/slice';

import {
  getPrices,
  getProcessingOptions,
  getStates,
  getUpsellOffers,
} from '_redux/variants/slice';

import { createClick } from '_redux/location/slice';
import { selectClickData } from '_redux/location/selector';

import Footer from '../Footer';
import Header from '../Header';
import ZendeskComponent from '../ZendeskComponent';
import { isMobile } from 'react-device-detect';

const StyledPageLayout = styled.div`
  overflow-x: hidden;
`;

const PageLayout = ({ children }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const headerRef = useRef(null);
  const divRef = useRef(null);
  const clickData = useSelector(selectClickData);

  const handleResize = () => {
    if (!isMobile && divRef.current && headerRef.current) {
      divRef.current.style.marginTop =
        headerRef.current.getBoundingClientRect().height + 'px';
    }
  };

  useEffect(() => {
    const handleRouteChange = () => {
      dispatch(createClick());
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [dispatch, router]);

  useEffect(() => {
    if (router.isReady && !clickData) {
      dispatch(createClick());
    }
  }, [dispatch, router, clickData]);

  useEffect(() => {
    dispatch(refreshDevice(getDeviceType()));
    dispatch(refreshSalePageURL(getSalePageURL()));
    dispatch(getPrices());
    dispatch(getProcessingOptions());
    dispatch(getProducts());
    dispatch(getStates());
    dispatch(getUpsellOffers());
  }, [dispatch]);

  useEffect(() => {
    if (divRef.current && headerRef.current) {
      divRef.current.style.marginTop =
        headerRef.current.getBoundingClientRect().height + 'px';
    }

    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, []);

  return (
    <StyledPageLayout>
      <Header headerRef={headerRef} />
      <div id="topEmptyHeightDiv" ref={divRef}></div>
      {children}
      <Footer />
      <ZendeskComponent />
    </StyledPageLayout>
  );
};

export default PageLayout;
